function initDrCartDrawer() {
  const drawer = document.getElementById('DrCartDrawer');
  if (!drawer) return;

  function openDrawer(event) {
    if (event) event.preventDefault();

    const wasOpen = drawer.classList.contains('is-open');

    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('dr-cart-drawer-open');

    // ===============================
    // GA4 — VIEW CART
    // Tracciamo dopo l'apertura visiva
    // per non rallentare la tendina.
    // Parte solo da chiuso → aperto.
    // ===============================
    if (!wasOpen) {
      setTimeout(() => {
        document.dispatchEvent(new CustomEvent('dr:view_cart', {
          detail: {
            currency: 'EUR'
          }
        }));
      }, 50);
    }
  }

  function closeDrawer(event) {
    if (event) event.preventDefault();

    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('dr-cart-drawer-open');
  }

  window.openDrCartDrawer = openDrawer;
  window.closeDrCartDrawer = closeDrawer;
}

document.addEventListener('click', function (event) {
  const openButton = event.target.closest('[data-dr-cart-toggle]');

  if (openButton) {
    event.preventDefault();

    if (typeof window.openDrCartDrawer === 'function') {
      window.openDrCartDrawer();
    }

    return;
  }

  const closeButton = event.target.closest('[data-dr-cart-close]');

  if (closeButton) {
    event.preventDefault();

    if (typeof window.closeDrCartDrawer === 'function') {
      window.closeDrCartDrawer();
    }
  }
});

document.addEventListener('keydown', function (event) {
  const drawer = document.getElementById('DrCartDrawer');

  if (
    event.key === 'Escape' &&
    drawer &&
    drawer.classList.contains('is-open') &&
    typeof window.closeDrCartDrawer === 'function'
  ) {
    window.closeDrCartDrawer();
  }
});

document.addEventListener('DOMContentLoaded', initDrCartDrawer);
window.initDrCartDrawer = initDrCartDrawer;


